export interface WebChatModel {
  automated_messages: AutomatedMessages;
  special_answers: SpecialAnswer[];
  web_chat_uuid: string;
  token_user: string;
  token_system: string;
  conversation_sid: string;
  chat_service_sid: string;
  terms_accepted: boolean;
}

export interface AutomatedMessages {
  [key: number]: AutomatedMessage;
}

export interface AutomatedMessage {
  text: string;
  message: string;
  trigger: 'automatically' | 'user_message';
  message_type: 'personal_info';
}

export interface SpecialAnswer {
  uuid: string | undefined;
  web_chat: string;
  message_type: string;
  message_id: string;
  answer: string;
  skipped: boolean;
}

export interface JoiningIdentity {
  joiningDate: Date;
  identityName: string;
}

export enum ConversationActionType {
  // Block = 'block_conversation',
  // ProceedBlocking = 'proceed_blocking',
  // Unblock = 'unblock_conversation',
  // Archive = 'archive',
  // ConciergeOnline = 'nurse_online',
  // ConciergeOffline = 'nurse_offline',
  UserOnline = 'web_conversation_user_online',
}

export const enum SysMsgIndex {
  Welcome = 1,
  FormOnline = 2,
  FormOffline = 3,
}

export interface WSMsg {
  source: 'web_conversation' | 'survey_conversation';
  action: ConversationActionType;
  conversation_sid: '';

  notification_type?: string;
}

export interface ChatBotHeader {
  title: string;
  subtitle: string;
}

export const DefaultConversations = {
  activeConversationSid: '',
  activeConversationJoinHistory: [],
  conversations: [],
  conversationsReady: false,
  status: '',
  statusString: 'Disconnected.',
};

export const DefaultChatBotHeader = {
  title: 'Virtual Assistant',
  subtitle: 'Ready to help',
};

export enum ChatModuleActiveRule {
  ALWAYS = 'always',
  NN_OFFLINE = 'nn_offline',
}

export const enum ChatModuleType {
  LiveChat = 'live_chat',
  KnowledgeBase = 'knowledgebase',
  TAIlor = 'kb_search',
  VirtualAssistant = 'virtual_assistant',
  TermsOfUse = 'terms_of_use',
  Container = 'container',
  IndicationSelector = 'indication_selector',
  IntegratedSearch = 'integrated_search',
  Pills = 'link_pills',
}

export const enum ItemActionEnum {
  StartChat = 'start_chat',
  OfflineChat = 'offline_chat',
  StartFirstVA = 'start_first_VA',
}

export const enum ButtonType {
  Default = 0,
  Primary = 10,
  Secondary = 20,
  Text = 30,
}

export interface FAQItem {
  body?: string;
  url?: string;
  link_url?: string;
  video_url?: string;
  video_name?: string;
  placeholder_url?: string;
  reg_id: FAQRegId;
  scale?: number;
  alignment?: string;
  button_text?: string;
  button_style?: 'primary' | 'secondary';
  icon_url?: string;
  icon_enabled?: boolean;
  redirect_link?: string;
}
interface FAQRegId {
  _type_val: FAQTypeValue;
  _version_val: string;
}
export enum FAQTypeValue {
  Text = 'kbtextelement',
  Image = 'kbimageelement',
  Video = 'kbvideoelement',
  HelpBlock = 'kb_article_action',
  Button = 'kbfaqbuttonelement',
}
export {};

export type ModuleProps = {
  module: ChatModule;
};

export interface ModuleConfig {
  always_display_more_help_text: boolean;
  display_suggested: boolean;
  search_box_text: string;
  enable_when_no_search_results: boolean;
  article_action: ArticleAction;
}

export interface ChatModule {
  module_type: ChatModuleType;
  url: string;
  placeholder?: string;
  header_icon: string;
  header_title: string;
  offline_icon?: string;
  offline_title?: string;
  is_active_rule?: ChatModuleActiveRule;
  items: [
    {
      title: string;
      action: ItemAction;
      valid_until_date_str: string;
    },
  ];
}

export interface SuggestedEntry {
  id: string;
  is_web_search?: boolean;
  external_link: string;
  title: string;
  custom_title?: boolean;
  render_json: FAQItem[];
  resource_link: string;
  description?: string;
  highlight_tag_text?: string;
}

export interface TAIlorChatModule extends ChatModule, ModuleConfig {
  config: {
    suggested_entries: SuggestedEntry[];
  };
}

export interface KnowledgeBaseChatModule extends ChatModule {
  config: ModuleConfig;
}

export interface LiveChatModule extends ChatModule {
  button_type: ButtonType;
  twilio_creds: {
    chat_service_sid: string;
    conversation_sid: string;
    token_system: string;
    token_user: string;
  };
}

export interface ArticleAction {
  link_name: string;
  block_text: string;
  button_text: RedirectFQAType;
  button_action: string;
  redirect_link: string;
  call_to: string;
}

export type ItemAction = 'start_chat' | 'offline_chat' | 'learn_about_product' | 'learn_about_copd' | 'other';

export type RedirectFQAType = 'live_chat' | 'call_now' | 'redirect';

export type TypeChat = 'chat' | 'VA';

export interface FAQPage extends SuggestedEntry {
  result_rank: number;
}
